import Vue from 'vue'
import axios from 'axios'
import { storeToRefs } from 'pinia'
import router from '@/router'
import useAuthStore from '@/store/auth'
import useCentralStore from '@/store/central'
import { clearDataStores } from '@/utils/store'

const axiosFlowIns = axios.create({
  baseURL: process.env.VUE_APP_FLOW,
  // baseURL: 'https://localhost:7294/api/',
})

axiosFlowIns.interceptors.request.use(
  config => {
    const { accessTokenFlow } = storeToRefs(useAuthStore())

    if (accessTokenFlow.value) return { ...config, headers: { Authorization: `Bearer ${accessTokenFlow.value}` } }

    return config
  },
  error => Promise.reject(error),
)

axiosFlowIns.interceptors.response.use(
  response => {
    if (!['post', 'put', 'delete'].includes(response.config.method)) return response

    Vue.$toast.success(response.data.message)

    return response
  },
  error => {
    const { status, data: { message } } = error.response

    if (status === 401) {
      const { empresaNomeFormatado, autoatendimentoNomeFormatado } = useCentralStore()

      clearDataStores()
      router.replace({
        name: 'auth-login',
        params: { empresaNomeFormatado, autoatendimentoNomeFormatado },
      })
      Vue.$toast.warning('Seu token expirou. Por favor, loque novamente.')

      return Promise.reject(error)
    }

    if (status === 400 || status === 422) {
      Vue.$toast.warning(message)
    } else if (status === 500) {
      Vue.$toast.error(message)
    }

    return Promise.reject(error)
  },
)

export default axiosFlowIns
